export interface ResolveInitialPincodeInput {
  cachedPincode: string | null;
  isPincodeUpdated: boolean;
  userContextPincode?: string | null;
  guessedPincode?: boolean;
}

export function resolveInitialPincode(input: ResolveInitialPincodeInput): string | null {
  const { cachedPincode, isPincodeUpdated, userContextPincode, guessedPincode } = input;

  if (isPincodeUpdated && cachedPincode) {
    return cachedPincode;
  }

  if (!guessedPincode && userContextPincode && userContextPincode.trim()) {
    return userContextPincode.trim();
  }

  if (cachedPincode) {
    return cachedPincode;
  }

  return null;
}
